export default __webpack_public_path__ + "361ad9a0e632f77b39167e620f28d5e5.png";